import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Card, Image, Button, Row, Col, Popconfirm } from "antd";
import { useNavigate } from "react-router-dom";

import { openNotification } from "@seims/shared";
import {
  RenderAuthenticated,
  RenderAnonymous,
} from "../../security/ToggleViews";
import { isAuthorizedRole, extendSession } from "../../security/AppSecurity";
import util from "../../utils/functions/custom";
import { Messages, Notify } from "../../services/custom/Messages";
import { recordError } from "../../utils/logService";
import usersService from "../../services/usersService";
import { getClosingDate } from "../nyscandidate/NysUtil";

const ProgrammeCard = ({ programme }) => {
  const subscribeButtonLabel = "Participate";
  const viewButtonLabel = "View Details";
  const launchButtonLabel = "Launch Application";
  const [link, setLink] = useState(programme?.link);

  const [buttonLabel, setButtonLabel] = useState(subscribeButtonLabel);

  const navigate = useNavigate();

  const handleNavigate = (selected) => {
    if (selected === launchButtonLabel || selected === viewButtonLabel) {
      return navigate(link);
    }
  };

  const redirectToProgrammeHome = () => {
    navigate(programme.launchLink)
  }

  const cancel = () => {};

  const onConfirm = async () => {
    let msg;
    const entity = "Participation request";
    try {
      const response = await usersService.programmeSubscription(programme.key);
      if (response && (response.status === 201 || response.status === 200)) {
        msg = util.parseMessage(Messages.SUCCESS, entity);
        openNotification(entity, msg, Notify.SUCCESS);
        extendSession(-1);
        // Add some delay to enable token refresh to complete
        setTimeout(() => {
          redirectToProgrammeHome();
        }, 700);
      } else {
        msg = util.parseMessage(Messages.FAILURE, entity);
        openNotification(entity, msg, Notify.ERROR);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.FAILURE, entity);
      openNotification(entity, msg, Notify.ERROR);
      recordError(error);
    }
  };

  useEffect(() => {
    // Handle navigation of already subscribed users
    if (isAuthorizedRole([programme?.role])) {
      setButtonLabel(launchButtonLabel);
      setLink(programme?.launchLink);
    }

    if (programme?.key === "nys-programme") {
      localStorage.removeItem("nys-subscription");
      isNysApplicationOpen();
    }
  }, []);

  const isNysApplicationOpen = async () => {
    const nysApplication = await getClosingDate();
    let _label = viewButtonLabel;
    if (nysApplication?.open) {
      const showApply = !isAuthorizedRole([programme?.role]);
      _label = showApply ? subscribeButtonLabel : launchButtonLabel;
      localStorage.setItem("nys-subscription", showApply);
    }
    setButtonLabel(_label);
  };

  return (
    <Card
      className={
        "programme-card " +
        (isAuthorizedRole([programme?.role]) ? "subscribed" : "not-subscribed")
      }
    >
      <Row className="subscription-title">
        <Col xs={24} md={24}>
          <div className="programme-name">{programme.value}</div>
        </Col>
      </Row>
      <br></br>
      <Row>
        <Col xs={24} md={24}>
          <div className="center-align programme-img">
            <Image
              preview={false}
              // width={programme.imageWidth}
              // height={programme.imageHeight}
              src={
                isAuthorizedRole([programme?.role])
                  ? programme.subscriptionImage
                  : programme.image
              }
            />
          </div>
        </Col>
      </Row>

      <div
        className="programme-content"
        dangerouslySetInnerHTML={{ __html: programme.description }}
      ></div>

      <div className="center-align programme-view-details">
        <RenderAnonymous>
          <Button
            className=""
            type={programme.active ? "primary" : "default"}
            shape="round"
            disabled={!programme.active}
            onClick={() => handleNavigate(viewButtonLabel)}
          >
            {programme.active ? "View Details" : programme.offlineText}
          </Button>
        </RenderAnonymous>
        <RenderAuthenticated>
          <div className="center-align">
            {programme.active ? (
              <>
                <Popconfirm
                  title="Are you sure you want to participate in this programme?"
                  onConfirm={() => onConfirm(programme)}
                  onCancel={() => cancel()}
                  okText="Yes"
                  cancelText="No"
                  disabled={buttonLabel === launchButtonLabel}
                >
                  <Button
                    type="primary"
                    shape="round"
                    // onMouseUp={() => cancel()}

                    onClick={() => handleNavigate(buttonLabel)}
                  >
                    {buttonLabel}
                  </Button>
                </Popconfirm>
                {/* <Button
                  type="default"
                  shape="round"
                  onClick={() => navigate(programme.link)}
                  style={{
                    marginTop: 22,
                    margin: "0 10px",
                  }}
                >
                  Read More
                </Button> */}
              </>
            ) : (
              <Button
                type="default"
                shape="round"
                // disabled={!programme.active}
                onClick={() => navigate(programme.link)}
                style={{
                  marginTop: 22,
                  margin: "0 10px",
                }}
              >
                {programme.offlineText}
              </Button>
            )}
          </div>
        </RenderAuthenticated>
      </div>
    </Card>
  );
};

// React components should validate prop types (javascript:S6774)
ProgrammeCard.propTypes = {
  programme: PropTypes.object.isRequired,
  // role: PropTypes.string.isRequired,
  // subscribed: PropTypes.bool
};

export default ProgrammeCard;
